var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout } from "~/core/decorator";
import app from '~/config/app.config';
import { StorageService } from '~/utils/storage.service';
var swapForum = /** @class */ (function (_super) {
    __extends(swapForum, _super);
    function swapForum() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.SplicingUrl = '';
        return _this;
    }
    swapForum.prototype.mounted = function () {
        var fixedUrl = app.url.server;
        var Iframe = document.getElementById('show-iframe');
        var deviceWidth = document.documentElement.clientWidth;
        var deviceHeight = document.documentElement.clientHeight;
        var url = fixedUrl.replace(fixedUrl.substr(fixedUrl.length - 4), 9080);
        var token = StorageService.getItem('userToken') || '';
        Iframe.style.width = deviceWidth + 'px';
        Iframe.style.height = deviceHeight + 'px';
        this.SplicingUrl = url + "/login/loginToken?token=" + token + "bbs";
    };
    swapForum = __decorate([
        Layout("workspace"),
        Component({ components: {} })
    ], swapForum);
    return swapForum;
}(Vue));
export default swapForum;
